import React from 'react';
import { CheckIcon, TargetIcon, TrendingUpIcon, ShieldIcon, ScissorsIcon, UsersIcon, BriefcaseIcon } from 'lucide-react';
export function ContentSection() {
  const benefits = [{
    icon: TargetIcon,
    text: "Dejar de cortar 'a ojo' y entender cada paso",
    desc: 'Aprendé la teoría detrás de cada movimiento para no depender de la suerte.'
  }, {
    icon: ScissorsIcon,
    text: 'Lograr fades limpios y profesionales',
    desc: 'Técnicas probadas para borrar líneas sin dejar marcas ni parches.'
  }, {
    icon: ShieldIcon,
    text: 'Trabajar con más seguridad en cada cliente',
    desc: 'Saber exactamente qué hacer sin importar el tipo de cabello o cráneo.'
  }, {
    icon: TrendingUpIcon,
    text: 'Evitar errores comunes que te hacen quedar amateur',
    desc: 'Conocé las fallas típicas y cómo solucionarlas antes de que pasen.'
  }, {
    icon: UsersIcon,
    text: 'Aplicar lo aprendido en clientes reales',
    desc: 'No es solo teoría, es práctica aplicable al día a día en la barbería.'
  }, {
    icon: BriefcaseIcon,
    text: 'Empezar a ver la barbería como un negocio',
    desc: 'Mejores cortes significan clientes más fieles y mejores precios.'
  }];
  return <section className="w-full bg-[#0b0b0b] py-20 md:py-32 px-4 relative border-t border-white/5" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="text-center mb-12 md:mb-20" data-id="element-90">
          <h2 className="text-3xl md:text-6xl font-black text-white leading-tight mb-6" data-id="element-91">
            Lo que vas a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-92">
              lograr
            </span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#c9a24a] to-[#b8913f] mx-auto mb-8 rounded-full" data-id="element-93"></div>
          <p className="text-gray-400 text-lg md:text-2xl font-semibold max-w-3xl mx-auto" data-id="element-94">
            Un sistema diseñado para transformar tu forma de trabajar y tus
            resultados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-95">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#141418] border border-white/10 rounded-2xl p-6 md:p-8 hover:border-[#c9a24a]/30 transition-colors group" data-id="element-96">
              <div className="bg-[#e53935]/10 w-12 h-12 md:w-16 md:h-16 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#e53935]/20 transition-colors border border-[#e53935]/20" data-id="element-97">
                <benefit.icon className="w-6 h-6 md:w-8 md:h-8 text-[#ef5350]" data-id="element-98" />
              </div>
              <h3 className="text-white font-bold text-lg md:text-xl leading-snug mb-3" data-id="element-99">
                {benefit.text}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-100">
                {benefit.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-[#c9a24a]/10 to-[#b8913f]/5 border border-[#c9a24a]/30 rounded-2xl p-6 md:p-10 text-center max-w-3xl mx-auto shadow-[0_0_30px_rgba(201,162,74,0.1)]" data-id="element-101">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-white font-black text-sm md:text-xl uppercase tracking-widest" data-id="element-102">
            <span className="flex items-center gap-2" data-id="element-103">
              <CheckIcon className="w-5 h-5 text-[#c9a24a]" data-id="element-104" />
              Ebook + Videos paso a paso
            </span>
            <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-[#c9a24a]/50" data-id="element-105"></span>
            <span className="flex items-center gap-2" data-id="element-106">
              <CheckIcon className="w-5 h-5 text-[#c9a24a]" data-id="element-107" />
              Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}